<template>
    <transition name="el-fade-in-linear">
        <div v-show="visible" :class="{'percent-loading-container': true, 'modal': option.modal}">
            <div class="loading-box">
                <div ref="progress" class="progress-panel active"></div>
                <div class="text">{{ txt }}</div>
            </div>
        </div>
    </transition>
</template>

<script>
const hundred = 100;
const defaultConfig = {
    delay: 20, // 执行速度
    spacing: 8, // 执行跨度
    modal: false, // 默认没有模态框
    rangArr: [80, 98], // 异步停顿区间
    isAysnc: false // 是否异步(暂停等待请求结束)
};
export default {
    props: {
        config: {
            type: Object,
            default() {
                return {
                    ...defaultConfig
                };
            }
        }
    },
    data() {
        return {
            endStep: 100,
            currentStep: 0,
            txt: 0,
            timer: null,
            dom: null,
            visible: false
        };
    },
    watch: {
        config: {
            handler(val) {
                this.option = { ...defaultConfig, ...val };
            },
            immediate: true
        }
    },
    methods: {
        to(step) {
            this.pause();

            let percent;
            step = step * 1;
            this.endStep = step;
            if (this.currentStep >= step) {
                this.currentStep = step;
                this.changeHtml(step.toFixed(2));
                return;
            }
            this.timer = setInterval(() => {
                const randomNum = Math.random() * this.option.spacing;
                this.currentStep += randomNum;
                if (this.currentStep >= step) {
                    this.currentStep = step;
                    this.pause();

                    // 进度条加载完成回调
                    if (!this.option.isAysnc) {
                        this.stop();
                    }
                }
                percent = this.currentStep.toFixed(2);
                this.changeHtml(percent);
            }, this.option.delay);
        },
        changeHtml(percent) {
            const { dom } = this;
            this.txt = percent + '%';
            dom.style.transform = `translateX(${percent}%)`;
        },
        start(step = hundred, isAysnc = false) {
            this.visible = true;
            const { rangArr } = this.option;
            this.option.isAysnc = isAysnc;
            if (isAysnc) {
                // 异步操作控制加载中停顿点
                const asyncStep = (Math.random() * (rangArr[1] - rangArr[0]) + rangArr[0]).toFixed(2);
                step = asyncStep;
            }

            this.to(step);
        },
        stop() {
            setTimeout(() => {
                this.visible = false;
                this.$emit('stop');
            }, 200);
            setTimeout(() => {
                this.reset();
            }, 400);
        },
        pause() {
            clearInterval(this.timer);
        },
        reset(step = 0) {
            this.pause();
            this.visible = false;
            this.currentStep = 0;
            this.to(step);
        }
    },
    mounted() {
        this.dom = this.$refs.progress;
        this.dom.transitionDelay = this.option.delay + 'ms';
        this.reset(50);
    }
};
</script>

<style lang="less">
.percent-loading-container {
    padding: 2px 0;
    text-align: center;
    &.modal {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .loading-box {
        width: 250px;
        height: 12px;
        margin: 0 auto;
        position: relative;
        background-color: #ddd;
        overflow: hidden;
        position: relative;
        .text {
            color: #000;
            font-size: 12px;
            line-height: 15px;
            text-align: right;
            margin-right: 5px;
            position: relative;
        }
    }
    .progress-panel {
        height: 100%;
        width: 100%;
        transform: translateX(0%);
        transition: all 50ms ease-in;
        position: absolute;
        left: -100%;
        top: 0;
        border-radius: 25px;
        background-color: var(--main-color);
        background-size: 40px 40px;
        &.active {
            animation: progress-bar-stripes 2s linear infinite;
        }
    }
}

@keyframes progress-bar-stripes {
    0% {
        background-position: 40px 0;
    }
    100% {
        background-position: 0 0;
    }
}
</style>
